import React from "react";
import "./index.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Projects from "./components/Projects";
import WhyGalaktik from "./components/WhyGalaktik";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppFloat from "./components/WhatsAppFloat";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <About />
      <Projects />
      <WhyGalaktik />
      <Contact />
      <Footer />
      <ScrollToTop />
      <WhatsAppFloat />
    </div>
  );
}

export default App; 